import React from 'react';
import { ToolbarButton } from '../../QuillToolbarStyles';
import { IsetToolbar } from '../CustomToolBar';

const applyHighlight = ({ quillRef, selection }) => {
  if (!quillRef || !quillRef.current || !selection) return;
  console.log('wkr');

  // React-Quill 에디터 컨테이너 가져오기
  const editor = quillRef.current.getEditor();
  const editorElement = editor?.container.querySelector('.ql-editor');

  if (!editorElement) return;

  // 선택된 텍스트의 범위
  const startIndex = selection.index;
  const endIndex = selection.index + selection.length;

  // 하이라이트 클래스를 추가
  const textNodes = Array.from(editorElement.childNodes) || null;
  let charCount = 0;

  textNodes.forEach((node: any) => {
    if (node.nodeType === Node.TEXT_NODE && node.textContent) {
      const nodeLength = node.textContent.length;

      if (charCount + nodeLength > startIndex && charCount < endIndex) {
        // 선택된 텍스트에 하이라이트 추가
        const highlightStart = Math.max(startIndex - charCount, 0);
        const highlightEnd = Math.min(endIndex - charCount, nodeLength);

        const beforeText = node.textContent.slice(0, highlightStart);
        const highlightText = node.textContent.slice(
          highlightStart,
          highlightEnd,
        );
        const afterText = node.textContent.slice(highlightEnd);

        // 새 DOM 노드 생성
        const span = document.createElement('span');
        span.textContent = highlightText;
        span.style.background = 'rgba(255, 255, 255, 0.84)';

        const fragment = document.createDocumentFragment();
        if (beforeText)
          fragment.appendChild(document.createTextNode(beforeText));
        fragment.appendChild(span);
        if (afterText) fragment.appendChild(document.createTextNode(afterText));

        node.replaceWith(fragment);
      }
    }

    charCount += node.textContent?.length || 0;
  });
};

const removeHighlight = ({ quillRef }) => {
  if (!quillRef || !quillRef.current) return;

  const editorElement = quillRef.current
    .getEditor()
    ?.container.querySelector('.ql-editor');
  if (!editorElement) return;

  // 하이라이트 제거
  const spans = editorElement.querySelectorAll('span');
  spans.forEach((span) => {
    if (span.style.background) {
      const textNode = document.createTextNode(span.textContent || '');
      span.replaceWith(textNode);
    }
  });
};

type Props = {
  setToolbar?: IsetToolbar;
  quillRef?: any;
};
function ToolbarSec1({ setToolbar, quillRef }: Props) {
  const { align, size, header } = setToolbar || {};
  return (
    <>
      {size && (
        <select
          className="ql-size"
          defaultValue="14"
          data-tooltip="글자 크기"
          onFocus={() => {
            try {
              const y =
                (document.scrollingElement?.scrollTop ?? window.pageYOffset) ||
                0;
              (window as any).__quillPrevScrollY = y;
            } catch (_) {}
          }}
          onChange={(e) => {
            try {
              const editor = quillRef?.current?.getEditor?.();
              const sel = editor?.getSelection?.();
              const y = (window as any).__quillPrevScrollY ?? null;
              setTimeout(() => {
                if (sel) editor.setSelection(sel);
                if (y != null) window.scrollTo(window.scrollX, y);
              }, 0);
            } catch (_) {}
          }}
        >
          <option value="11">11</option>
          <option value="12">12</option>
          <option value="13">13</option>
          <option value="14">14</option>
          <option value="15">15</option>
          <option value="16">16</option>
          <option value="18">18</option>
          <option value="20">20</option>
          <option value="24">24</option>
          <option value="32">32</option>
          <option value="48">48</option>
        </select>
      )}

      {header && (
        <>
          <select
            className="ql-header"
            defaultValue="본문"
            data-tooltip="문단 모양"
            onFocus={() => {
              try {
                const y =
                  (document.scrollingElement?.scrollTop ??
                    window.pageYOffset) ||
                  0;
                (window as any).__quillPrevScrollY = y;
              } catch (_) {}
            }}
            onChange={() => {
              try {
                const editor = quillRef?.current?.getEditor?.();
                const sel = editor?.getSelection?.();
                const y = (window as any).__quillPrevScrollY ?? null;
                setTimeout(() => {
                  if (sel) editor.setSelection(sel);
                  if (y != null) window.scrollTo(window.scrollX, y);
                }, 0);
              } catch (_) {}
            }}
          >
            <option value="">본문</option>
            <option value="1">제목 1</option>
            <option value="2">제목 2</option>
          </select>
        </>
      )}
      {align && (
        <>
          <ToolbarButton className="ql-bold" data-tooltip="굵게" />
          <ToolbarButton className="ql-italic" data-tooltip="기울임꼴" />
          <ToolbarButton className="ql-underline" data-tooltip="밑줄" />
          <select
            className="ql-align"
            data-tooltip="정렬"
            onFocus={() => {
              try {
                const y =
                  (document.scrollingElement?.scrollTop ??
                    window.pageYOffset) ||
                  0;
                (window as any).__quillPrevScrollY = y;
              } catch (_) {}
            }}
            onChange={() => {
              try {
                const editor = quillRef?.current?.getEditor?.();
                const sel = editor?.getSelection?.();
                const y = (window as any).__quillPrevScrollY ?? null;
                setTimeout(() => {
                  if (sel) editor.setSelection(sel);
                  if (y != null) window.scrollTo(window.scrollX, y);
                }, 0);
              } catch (_) {}
            }}
          />
        </>
      )}
    </>
  );
}

export default ToolbarSec1;
